import React from 'react'
import { Drawer, Box, Button, Container } from '@material-ui/core'

import { ArrowLeft, ArrowRight } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { useGlobalContext, sideBarRightVisibilityChanged } from '../../state'
import { Pilares } from './Pilares/index'
import { FeaturesTable } from './FeaturesTable/index'
import { IndicatorData } from './IndicatorData/index'
import { IndicatorDefinition } from './IndicatorDefinition/index'
import PropagateLoader from 'react-spinners/PropagateLoader'

const content = new Map([
  ['dataTable', <Pilares key="dataTable" />],
  ['featuresDataTable', <FeaturesTable key="featuresDataTable" />],
  ['indicatorData', <IndicatorData key="indicatorData" />],
  ['indicatorDefinition', <IndicatorDefinition key="indicatorDefinition" />]
])

export const SideBarRight = () => {
  const {
    state: {
      sideBarRight: { isOpen, selectedType, loadingIssues }
    },
    dispatch
  } = useGlobalContext()

  const classes = useStyles()

  return (
    <Drawer
      variant="permanent"
      anchor="right"
      classes={
        isOpen ? { paper: classes.openDrawer } : { paper: classes.closeDrawer }
      }
    >
      <Container className={classes.container}>
        <Container className={classes.btnContainer}>
          <Button
            className={classes.btnPanel}
            variant="outlined"
            onClick={() => {
              dispatch(
                sideBarRightVisibilityChanged({
                  isOpen: !isOpen
                })
              )
            }}
          >
            {isOpen ? <ArrowRight /> : <ArrowLeft />}
          </Button>
        </Container>
        {isOpen && (
          <>
            {loadingIssues ? (
              <Box className={classes.loaderContainer}>
                <PropagateLoader color="#658490" />
              </Box>
            ) : (
              <Box className={classes.contentContainer}>
                {selectedType && content.get(selectedType)}
              </Box>
            )}
          </>
        )}
      </Container>
    </Drawer>
  )
}

const useStyles = makeStyles((theme) => ({
  openDrawer: {
    ...theme.sidebar,
    width: '35%'
  },
  closeDrawer: {
    ...theme.sidebar,
    width: theme.spacing(2)
  },
  container: {
    display: 'grid',
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    gridTemplateColumns: `${theme.spacing(2)}px auto`
  },
  btnContainer: {
    height: '100%',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center'
  },
  btnPanel: {
    margin: 0,
    padding: 0,
    minWidth: 0,
    width: theme.spacing(2),
    height: '100%'
  },
  contentContainer: {
    marginTop: theme.spacing(2.4)
  },
  loaderContainer: {
    margin: 'auto'
  }
}))
